/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Component imports
import { Button, Flex } from "antd";
import { Container } from "@/components/UI/Container";

// Misc imports
import replaceUrlParams from "@/utils/string/replaceUrlParams";
import { useWorkspacesList } from "@/api/workspaces";
import { NAV_PROJECTS } from "@/constants";
import { queryClient } from "@/utils/queryClient";
import { ITokens } from "@/interfaces/User.interface";

export const NotFound404 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const authContext = useContext(AuthContext);
  const userAuth:ITokens | undefined = queryClient.getQueryData(["user-auth"]);
  const { access: accessToken } = userAuth || {};

  // Now, you have access to the authentication state and actions
  // const { accessToken } = authContext;

  const { data: workspacesList } = useWorkspacesList({
    enabled: !!accessToken,
  });
  const [workspaceId, setWorkspaceId] = useState<string | null>(workspacesList ? workspacesList[0]?.uuid : null);

  useEffect(() => {
    if (!workspacesList) {
      return;
    }
    setWorkspaceId(workspacesList[0] ? workspacesList[0].uuid : null);
  }, [workspacesList]);

  return (
    <Container>
      <Flex className="not-found-404" justify="center" align="center" vertical={true}>
        <h2>404</h2>
        <p>{t("404.title")}</p>
        <Button
          type="primary"
          onClick={() =>
            navigate(
              replaceUrlParams(NAV_PROJECTS, {
                workspaceId,
              })
            )
          }
        >
          {t("404.button")}
        </Button>
      </Flex>
    </Container>
  );
};
